<header class="masthead" style="position: fixed;">
	<div class="navbar">
		<div class="left-header-subscribe">
				<a class="navbar-brand js-scroll-trigger" href="javascript:;" routerLink="/home"><img src="assets/img/logo.svg"></a>
		</div>

		<div class="right-header" style="width: 500px;">
      <a class="nav-link button download-btn" data-toggle="modal" (click)="downloadAllImages(fileInfos)" style="width: 180px; cursor: pointer; height: 42px; color: #ffffff; margin-right: 24px;" *ngIf="!showShareDownloadLoader && showDownloadButton">Download All</a>

      <a class="nav-link button download-btn" data-toggle="modal" *ngIf="showShareDownloadLoader" style="width: 180px; height: 42px; margin-right: 24px;"><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;"></a>

      <a *ngIf="!currentUser" class="nav-link button" data-toggle="modal" (click)="openLoginScreen()" data-target="#signup-popup" style="background: #DEEBFF; color: #2d7cff; cursor: pointer;">Start for Free</a>

			<div class="menu-pop-over user-name" *ngIf="currentUser  && !mobileView">
				<button id="user-pop-over" data-toggle="dropdown" class="user-icon-btn">
					<img *ngIf="!userPic" src="assets/img/user-profile.svg">
					<img *ngIf="userPic" src="{{userPic}}">
				</button>
				<div class="dropdown-menu" aria-labelledby="user-pop-over">
					<div class="dropdown-container">
						<div class="upper-container">
							<div class="name-pro">
								<h6>{{currentUser.firstName+" "+currentUser.lastName}}</h6>
							</div>
							<div class="email">{{currentUser.email}}</div>
						</div>
						<div class="hr-line"></div>
						<ul class="dropdown-list list-group">
							<a routerLink="/home" target="_blank"><li class="list-group-item">Go to Homepage</li></a>
							<a (click)="goToMarketplace()"><li class="list-group-item">Go to Marketplace</li></a>
							<a routerLink="/feedbacks" target="_blank"><li class="list-group-item">Feedback & bugs report</li></a>
							<a routerLink="/faq" target="_blank"><li class="list-group-item">FAQ</li></a>
							<a (click)="goProClick()" *ngIf="planName == 'Free'">
								<li class="list-group-item" style="background-color: var(--primaryColorLightBlue); border-radius: 4px; margin-top: 8px; display: block;"><b style="color: #2d7cff">Upgrade plan:</b><span> You're on the free plan. Upgrade now for unlimited storage, access, members, and more.</span></li>
							</a>
						</ul>
						<div class="logout-btn">
							<button type="button" class="ant-btn" (click)="logOut()"><a>Logout</a></button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</header>

<section *ngIf="mainSection">
	<div class="main-container">
		<div class="side-bar hide-sidebar" id="side-bar">
			<div class="left-sticky-bar" id="left-sticky-bar">
				<div class="side-bar-list-container">
					<div class="sidebar-list-group">
						<div class="share-main-workspace-name" style="margin-top: 80px;">
							<h5>{{workspaceName}}</h5>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="center-container">
			<div>
				<div class="homepage-heading">
					<div class="homepage-heading_">
					<div class="homepage-heading-title">
						<h2>{{boardname}}</h2>
						<span class="user-illus-count">Assets ({{totalIllusCount}})</span>
					</div>

					<div class="ant-select ant-select-borderless ant-select-single ant-select-show-arrow home-switch-view-select d-flex">

					</div>
					</div>
				</div>

				<div class="download-delete-section" *ngIf="downloadDelete && showDownloadButton">
						<button type="button" class="ant-btn-download ant-btn-default svg-download" data-toggle="dropdown" (click)="downloadMultipleImage()">
							<span style="text-transform: uppercase;">Download ({{count}})</span>
						</button>
				</div>


					<div class="illus-rollup-view row mb-5 mt-2" *ngFor="let imgss of fileInfos">
						<ul class="new-board-media-list" *ngFor="let imges of imgss.images; let i = index">
							<li>
							<div class="inner-card">
								<div class="illus-img-container">
									<!-- <div class="img-type">
										<span>{{imges.image_format}}</span>
									</div> -->
									<div class="img-share-comment dropdown">
										<span *ngIf="imges.is_fav == true" class="anticon img-favourite"><svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
												<title>Favourite</title>
												<g id="Icons/Star/Selected" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
														<path d="M19.9582598,9.79420394 C19.853521,9.47022168 19.5661608,9.24011372 19.2261869,9.20947335 L14.6081582,8.79015196 L12.7820653,4.51600335 C12.6474186,4.20276356 12.3407707,4 12.0000645,4 C11.6593582,4 11.3527103,4.20276356 11.2180636,4.5167358 L9.39197075,8.79015196 L4.77320957,9.20947335 C4.43384607,9.24084615 4.14721826,9.47022168 4.04186909,9.79420394 C3.93651992,10.1181862 4.03381224,10.4735412 4.29053217,10.6975455 L7.78121503,13.758897 L6.7518939,18.2930615 C6.67657475,18.6264434 6.8059723,18.971056 7.08259016,19.1710119 C7.23127532,19.2784363 7.40522961,19.333125 7.58064877,19.333125 C7.73189746,19.333125 7.88192541,19.2923526 8.01657214,19.2117843 L12.0000645,16.8309909 L15.9820919,19.2117843 C16.2734806,19.3870814 16.6407988,19.3710898 16.9168063,19.1710119 C17.1935462,18.9704456 17.3228217,18.6257109 17.2475026,18.2930615 L16.2181814,13.758897 L19.7088643,10.6981559 C19.9655842,10.4735412 20.063609,10.1187965 19.9582598,9.79420394 Z" id="Star" fill="#FFC107" fill-rule="nonzero"></path>
												</g>
										</svg></span>

										<!-- <div class="img-share-comment dropdown"> -->
										<div data-toggle="dropdown" *ngIf="showDownloadButton">
											<span class="anticon img-more-options"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
											<circle cx="6" cy="12" r="2" fill="white"/>
											<circle cx="12" cy="12" r="2" fill="white"/>
											<circle cx="18" cy="12" r="2" fill="white"/>
											</svg>
											</span>

											<div class="dropdown-menu" aria-labelledby="dropdownMenuButton" data-toggle="dropdown">
												 <ul class="list-group">
													 <li class="" (click)="downloadSingleImage(imges.id, imges.title)">
	                           <img src="assets/img/download-black.svg" alt="">
	                           <a class="text" href="javscript:;" style="color:#000">Download</a>
													 </li>
												 </ul>
											 </div>
									 	</div>
									</div>

									<video src={{imges.image}} *ngIf="imges.image_format == 'MP4' || imges.image_format == 'WEBM' || imges.image_format == 'FLV' || imges.image_format == 'WMV' || imges.image_format == 'MOV'" style="height: 184px;" controls (click)="currentIllus=imges; openImgDialog(imgMainModal, currentIllus.title, i);"></video>

									<img src={{imges.image}} *ngIf="imges.image_format == 'PNG' || imges.image_format == 'JPG'  || imges.image_format == 'SVG' || imges.image_format == 'JPEG' || imges.image_format == 'GIF' || imges.image_format == 'BMP'" (click)="currentIllus=imges; openImgDialog(imgMainModal, currentIllus.title, i);">

                  <img src={{imges.image_jpg}} *ngIf="imges.image_format == 'TIFF' || imges.image_format == 'WEBP'" (click)="currentIllus=imges; openImgDialog(imgMainModal, currentIllus.title, i);">

                  <img src="assets/img/ai-icon.svg" *ngIf="imges.image_format == 'AI'" (click)="currentIllus=imges; openImgDialog(imgMainModal, currentIllus.title, i);" style="height: 184px;">

									<img src="assets/img/eps-icon.svg" *ngIf="imges.image_format == 'EPS'" (click)="currentIllus=imges; openImgDialog(imgMainModal, currentIllus.title, i);" style="height: 184px;">

									<img src="assets/img/zip-icon.svg" *ngIf="imges.image_format == 'ZIP'" (click)="currentIllus=imges; openImgDialog(imgMainModal, currentIllus.title, i);" style="height: 184px;">

									<img src="assets/img/xlsx-icon.svg" *ngIf="imges.image_format == 'XLSX'" (click)="currentIllus=imges; openImgDialog(imgMainModal, currentIllus.title, i);" style="height: 184px;">

									<img src="assets/img/doc-icon.svg" *ngIf="imges.image_format == 'DOCX' || imges.image_format == 'DOC'" (click)="currentIllus=imges; openImgDialog(imgMainModal, currentIllus.title, i);" style="height: 184px;">

									<img src="assets/img/pages.svg" (click)="currentIllus=imges; openImgDialog(imgMainModal, currentIllus.title, i);" *ngIf="imges.image_format == 'NUMBERS' || imges.image_format == 'PAGES'">

                  <img src="assets/img/placeholder.png" *ngIf="imges.image_format == 'PSD'" style="height: 184px;">

                  <pdf-viewer style="width: 150px; height: 150px;" *ngIf="imges.image_format == 'PDF'" [src]="imges.image" [original-size]="true" [render-text]="true" [rotation]="0"
                  [show-all]="true" [fit-to-page]="true" [zoom]="1" [zoom-scale]="'page-width'"
                  [stick-to-page]="true" [external-link-target]="'blank'" [autoresize]="true"
                  [show-borders]="false" class="pdf-viewer" [show-all]="false" (page-rendered)="pageRendered()" (click)="currentIllus=imges; openImgDialog(imgMainModal, currentIllus.title, i);"></pdf-viewer>

									<label *ngIf="!imageSelected" class="ill-add-btn select-illus" [style.background-color] = "changeColor[i]  ? '#ffffff' : '#e4e4e4'">
									<input type="checkbox" value="illus_2" id="illus_2" class="d-none" (click)="changeColor[i]=!changeColor[i]; showDownloadDeleteButtons(changeColor[i], i,  imges.id, imges.title)">
									<span class="anticon anticon-check">
									</span></label>

									<label *ngIf="imageSelected" class="ill-add-btn- select-illus" [style.background-color] = "changeColor[i]  ? 'green' : '#e4e4e4'">
									<input type="checkbox" value="illus_2" id="illus_2" class="d-none" (click)="changeColor[i]=!changeColor[i]; showDownloadDeleteButtons(changeColor[i], i,  imges.id, imges.title)">
									<span class="anticon anticon-check">
										<svg *ngIf="changeColor[i] == false" viewBox="64 64 896 896" focusable="false" class="nike-mark" data-icon="check" width="1em" height="1em" fill="#e4e4e4" aria-hidden="true"><path d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"></path></svg>
										<svg *ngIf="changeColor[i] == true" viewBox="64 64 896 896" focusable="false" class="nike-mark-show" data-icon="check" width="1em" height="1em" fill="white" aria-hidden="true"><path d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"></path></svg>
									</span></label>
								</div>
                <div class="hover-style" (click)="currentIllus=imges; openImgDialog(imgMainModal, currentIllus.title, i);">
									<div class="title"><b>{{ imges.title }}</b>
										<br>
										<span *ngIf="imges.size > 1000">{{imges.image_format}} - {{ imges.size/1000 }} MB</span>
										<span *ngIf="imges.size < 1000">{{imges.image_format}} - {{ imges.size }} KB</span>
									</div>
								</div>
							</div>
				</li>
			</ul>
			</div>

			<div *ngIf="downloadDelete && showDownloadButton" class="">
				<div class="total-img-count center total-board-scenarios">
					<p style="color: #fff; float: left">{{count}} {{fileText}} selected</p>

					<button style="text-align: end; float: right; margin-top: -4px;" (click)="cancelImageSelection()" type="button" class="close" data-dismiss="modal" aria-label="Close" mat-raised-button #tooltip="matTooltip"
					matTooltip="Cancel"
					matTooltipPosition="above"
					matTooltipClass="custom-tooltip">
						<svg id="Icons_Navigation_Cross_Black" data-name="Icons/Navigation/Cross/Black" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
							<defs>
								<clipPath id="clip-path">
									<rect id="Mask" width="18" height="18" fill="currentColor"/>
								</clipPath>
							</defs>
							<g id="Group_4" data-name="Group 4" transform="translate(3 3)">
								<g id="Close_icon" data-name="Close icon">
									<rect id="Mask-2" data-name="Mask" width="18" height="18" fill="none"/>
									<g id="Close_icon-2" data-name="Close icon" clip-path="url(#clip-path)">
										<path id="Shape" d="M0,0,11.25,11.25" transform="translate(3.375 3.375)" fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/>
										<path id="Shape-2" data-name="Shape" d="M11.25,0,0,11.25" transform="translate(3.375 3.375)" fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/>
									</g>
								</g>
							</g>
						</svg>
					</button>

					<button style="text-align: end; float: right; margin-top: -2px; margin-right: 20px;" (click)="downloadMultipleImage()" type="button" class="close" data-dismiss="modal" aria-label="Close" mat-raised-button #tooltip="matTooltip"
					matTooltip="Download"
					matTooltipPosition="above"
					matTooltipClass="custom-tooltip">
						<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M8.5 10.5V0.5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
						<path d="M4.5 7.74023L8.5 11.7402L12.5 7.74023" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
						<path d="M16.5 15.7402H0.5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
					</button>
				</div>
			</div>
			</div>
		</div>
		<div class="loader-scenarios" *ngIf="showTopRightLoader">
			<img class="img-up-loader" style="width: 30px;" src="assets/img/img-up.svg" alt="">
		</div>

		<div class="loader-scenarios-success-msgs" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="200" *ngIf="sendSuccessfulMsg">
			<span class="ant-avatar-selected">
				<svg width="18" height="14" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M1 5L4.58824 9L13 1" stroke="#0fa636" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
			</span>
			<p>{{successfullMessage}}</p>
		</div>

		<div class="loader-scenarios-error-msgs" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="200" *ngIf="sendSuccessfulErrorMsg">
			<p>{{sendSuccessfulErrorMessage}}</p>
		</div>
	</div>
</section>


<section class="url-expired-section" *ngIf="noDataSection">
	<div class="main-container">
		<div class="side-bar hide-sidebar" id="side-bar">
			<div class="left-sticky-bar" id="left-sticky-bar">
				<div class="side-bar-list-container">
					<div class="sidebar-list-group">
					</div>
				</div>
			</div>
		</div>
		<div class="center-container">
			<div class="no-data-container">
        <div class="no-result-section">
  				<h3>{{showErrorMessage}}</h3>
  				<div class="no-data-img">
  					<img src="assets/img/no-exist.svg" style="width: 400px;">
  					<p>The page you are looking for is invalid or expired.</p>
  				</div>
  				<br />
  				<br />
  			</div>
		  </div>
	  </div>
  </div>
</section>

<ng-template #imgMainModal let-imgMainModal>
		<div class="modal-dialog modal-dialog-centered svg-modal" role="document">
			<div class="modal-content">
				<div class="modal-body d-flex">
					<div class="svg-preview">
						<div class="modal-sep">
							<button (click)="imgMainModal.close()" type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true"><svg width="26px" height="26px" viewBox="0 0 26 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
										<title>Cross</title>
										<g id="Page-1" stroke="none" stroke-width="2" fill="none" fill-rule="evenodd">
												<g id="DAM-Landing-Page-Copy-3" transform="translate(-911.000000, -23.000000)">
														<g id="Cross" transform="translate(912.000000, 24.000000)">
																<rect id="Rectangle" x="0" y="0" width="24" height="24" rx="4"></rect>
																<g id="Group-3" transform="translate(12.000000, 12.000000) rotate(45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round">
																		<line x1="8" y1="0" x2="8" y2="16" id="Path-8"></line>
																		<line x1="8" y1="0.421052632" x2="8" y2="15.5789474" id="Path-8-Copy" transform="translate(8.000000, 8.000000) rotate(-90.000000) translate(-8.000000, -8.000000) "></line>
																</g>
														</g>
												</g>
										</g>
								</svg></span>
							</button>
							<span class="ml-5"></span>
							<span class="svg-details-preview-toggle-btn">
								<ul>
									<li>
											<span (click)="hideDialogClick()" role="img" aria-label="arrow-right" id="aero-to-toggle" class="anticon anticon-arrow-right"><svg width="25px" height="20px" viewBox="0 0 17 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
													<title></title>
													<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
															<g id="DAM-Landing-Page-Copy-3" transform="translate(-916.000000, -75.000000)" fill="#FFFFFF">
																	<g id="Switch-account" transform="translate(912.000000, 72.000000)">
																			<g id="Group-7" transform="translate(4.000000, 3.000000)">
																					<path d="M12.3486,7.8193 L4.6516,7.8193 C4.3756,7.8193 4.1516,7.5953 4.1516,7.3193 C4.1516,7.0433 4.3756,6.8193 4.6516,6.8193 L11.1416,6.8193 L9.0066,4.6843 C8.8116,4.4893 8.8116,4.1733 9.0066,3.9773 C9.2026,3.7823 9.5186,3.7823 9.7136,3.9773 L12.7026,6.9653 C12.8456,7.1083 12.8886,7.3243 12.8106,7.5103 C12.7336,7.6973 12.5506,7.8193 12.3486,7.8193" id="Fill-1"></path>
																					<path d="M7.6401,12.6865 C7.5121,12.6865 7.3841,12.6375 7.2861,12.5405 L4.2981,9.5515 C4.1551,9.4095 4.1121,9.1935 4.1901,9.0065 C4.2671,8.8205 4.4501,8.6985 4.6521,8.6985 L12.3481,8.6985 C12.6251,8.6985 12.8481,8.9215 12.8481,9.1985 C12.8481,9.4745 12.6251,9.6985 12.3481,9.6985 L5.8591,9.6985 L7.9941,11.8325 C8.1891,12.0285 8.1891,12.3445 7.9941,12.5405 C7.8961,12.6375 7.7681,12.6865 7.6401,12.6865" id="Fill-3"></path>
																					<path d="M2.5,1 C1.673,1 1,1.673 1,2.5 L1,14.501 C1,15.327 1.673,16 2.5,16 L14.5,16 C15.327,16 16,15.327 16,14.501 L16,2.5 C16,1.673 15.327,1 14.5,1 L2.5,1 Z M14.5,17 L2.5,17 C1.122,17 0,15.879 0,14.501 L0,2.5 C0,1.121 1.122,0 2.5,0 L14.5,0 C15.879,0 17,1.121 17,2.5 L17,14.501 C17,15.879 15.879,17 14.5,17 L14.5,17 Z" id="Fill-5"></path>
																			</g>
																	</g>
															</g>
													</g>
											</svg></span>
									</li>
									<li>
									</li>
								</ul>
							</span>
							<div class="svg-preview-container">
								<span *ngIf="totalIllusCount > 1" aria-hidden="true" (click)="previousImage(currentIllusPosition, fileInfos)" class="previos-icon">
									<svg style="transform: rotate(180deg);" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M13 23.1421L20.0711 16.071L13 8.99995" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
									</svg>
								</span>
                <input type="checkbox" id="zoomCheck" style="display: none;">
  							<label for="zoomCheck">
  								<img [src]="currentIllus.image" alt="download illustrations" *ngIf="currentIllus.image_format == 'PNG' || currentIllus.image_format == 'JPG'  || currentIllus.image_format == 'SVG' || currentIllus.image_format == 'JPEG' || currentIllus.image_format == 'GIF' || currentIllus.image_format == 'BMP'">

                  <img [src]="currentIllus.image_jpg" *ngIf="currentIllus.image_format == 'TIFF' || currentIllus.image_format == 'WEBP'">

                  <img src="assets/img/ai-icon.svg" *ngIf="currentIllus.image_format == 'AI'">

									<img src="assets/img/eps-icon.svg" *ngIf="currentIllus.image_format == 'EPS'">

									<img src="assets/img/xlsx-icon.svg" *ngIf="currentIllus.image_format == 'XLSX'">

									<img src="assets/img/doc-icon.svg" alt="download illustrations" *ngIf="currentIllus.image_format == 'DOCX' || currentIllus.image_format == 'DOC'">

									<img src="assets/img/pages.svg" *ngIf="currentIllus.image_format == 'NUMBERS' || currentIllus.image_format == 'PAGES'">

                  <img src="assets/img/placeholder.png" alt="download illustrations" *ngIf="currentIllus.image_format == 'PSD'">
                </label>

                <pdf-viewer *ngIf="currentIllus.image_format == 'PDF'" [src]="currentIllus.image" [original-size]="true" [render-text]="true" [rotation]="0"
                [show-all]="true" [fit-to-page]="true" [zoom]="1" [zoom-scale]="'page-width'"
                [stick-to-page]="true" [external-link-target]="'blank'" [autoresize]="true"
                [show-borders]="false" class="pdf-viewer" [show-all]="false" (page-rendered)="pageRendered()"></pdf-viewer>

								<video src={{currentIllus.image}} *ngIf="currentIllus.image_format == 'MP4' || currentIllus.image_format == 'WEBM' || currentIllus.image_format == 'FLV' || currentIllus.image_format == 'WMV' || currentIllus.image_format == 'MOV'" style="height: 184px;" controls></video>
								<span *ngIf="totalIllusCount > 1" class="next-icon" aria-hidden="true" (click)="nextImage(currentIllusPosition, fileInfos)">
									<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M13 23.1421L20.0711 16.071L13 8.99995" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
									</svg>
								</span>
							</div>
					</div>
				</div>

				<div class="svg-details bg-white" id="svg-details-toggle-work" *ngIf="hideDialogSection">
 				<div class="">
 				<div class="modal-sep">
 						<div class="svg-details-div">
 							<button type="button" class="ant-btn border-0 mb-2 ant-btn-ghost ant-btn-icon-only hide-on-bg-scr" id="dismiss-svg-details" ant-click-animating-without-extra-node="false"><span role="img" aria-label="left" class="anticon anticon-left" style="font-size: 16px;"><svg viewBox="64 64 896 896" focusable="false" class="" data-icon="left" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"></path></svg></span></button>

							<h6 class="svg-title">{{currentIllus.title}}</h6>

							<p *ngIf="currentIllus.size > 1000"><small><span class="text-muted">{{currentIllus.size/1000}}MB Uploaded by <span style="color: #000000">{{currentIllus.uploaded_by_name}}</span> </span></small></p>

 							<p *ngIf="currentIllus.size < 1000"><small><span class="text-muted">{{currentIllus.size}}KB Uploaded by <span style="color: #000000">{{currentIllus.uploaded_by_name}} </span></span></small></p>

							<div class="flex mt-3">
								<span class="d-inline-flex">
									<div class="dropdown">
										<button *ngIf="showDownloadButton" type="button" class="ant-btn ant-btn-primary svg-download" data-toggle="dropdown" (click)="downloadSingleImage(currentIllus.id, currentIllus.title)"><span role="img" aria-label="download" class="anticon anticon-download"><svg viewBox="64 64 896 896" focusable="false" class="" data-icon="download" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"></path></svg></span><span style="text-transform: uppercase;">Download</span><span> </span></button>


										<!-- Pick this line if need to show image format -->
										<!-- {{currentIllus.image_format}} -->

									<!-- <div class="dropdown-menu p-3 border-shadow download-asset-format  dropdown-menu-right">
										<div *ngIf="currentIllus.image_format == 'svg'; else elseBlock" class="d-flex"> -->


											<!-- <label>Filetype</label> -->
											<!-- <ul class="list-unstyled d-flex">
											<li class="active-type">SVG</li>
											<li>PNG</li>
											<li>JPG</li>
										</ul> -->


									<!-- </div>

										<ng-template #elseBlock>
											<div #elseBlock class="d-flex">
												<label>Filetype</label>
												<ul class="list-unstyled d-flex">
													 -->
													<!-- <li class="active-type">SVG</li> -->

													<!-- <li class="active-type">PNG</li>
													<li>JPG</li>
											</ul> -->
										<!-- </div>
										</ng-template> -->

										<!-- <div class="mt-2"> -->
											<!-- <button class="w-100 bg-dark text-white">
												<svg viewBox="64 64 896 896" focusable="false" class="" data-icon="download" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"></path></svg>
											Download Image</button> -->

											<!-- <button class="w-100 bg-dark text-white" *ngIf="!isSVG">
												<svg viewBox="64 64 896 896" focusable="false" class="" data-icon="download" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"></path></svg>
											Download as {{fileTypeText}}</button> -->
										<!-- </div> -->
									<!-- </div> -->
									</div>
								</span>
							</div>

							<hr class="mt-4"/>
							<div><small class="font-weight-bold text-muted">Board</small></div>
							<div class="illus-name">
								<ul class="list-unstyled p-0">
									<li><button class="illus-name-btn">{{currentIllus.board_title}}</button></li>
								</ul>
							</div>

							<div class="illus-tag illus-tags-display">
							<small class="text-uppercase text-muted" *ngIf="currentIllus.tags.length > 0">Tags Added</small>
							<div class="image-tags-div">
								<ul class="list-unstyled p-0" *ngFor="let tag of currentIllus.tags; let i=index">
									<li><button class="illus-tag-btn">
											<span class="tags-text-entry"><a href="javscript:;">{{tag}}</a></span>
									</button></li>
								</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			</div>
		</div>
	</div>
</ng-template>
